const TENANT_CONTENT_MANAGER_ROLES = new Set(['admin', 'moderator', 'owner']);

// Roles that manage Challenges for their tenant. General content-manager roles
// (admin/moderator) deliberately do NOT grant Challenge management — Challenges
// administration is a separate, tenant-scoped permission (challenge_admin). The
// platform administrator is granted Challenges management separately via the
// Admin Tools authorization path, never by hard-coded business/challenge emails.
const CHALLENGE_ADMIN_ROLES = new Set(['challenge_admin', 'owner']);

export function canManageTenantContent(role: string | null | undefined): boolean {
  return TENANT_CONTENT_MANAGER_ROLES.has(String(role || '').trim().toLowerCase());
}

export function isChallengeAdmin(role: string | null | undefined): boolean {
  return CHALLENGE_ADMIN_ROLES.has(String(role || '').trim().toLowerCase());
}

